// extracted by mini-css-extract-plugin
module.exports = {"events":"Events_events__1oEAo","title":"Events_title__2x-81","list":"Events_list__143ca","empty":"Events_empty__1t81A"};